/* eslint-disable import/no-extraneous-dependencies */
import { Step } from 'react-joyride'
import { productTourTypes } from './actionTypes'
import { SetRun, SetStepIndex, SetStep } from './types'

export const SetRunAction = (payload: boolean): SetRun => ({
    type: productTourTypes.SET_RUN,
    payload,
})

export const SetStepIndexAction = (payload: number): SetStepIndex => ({
    type: productTourTypes.SET_STEP_INDEX,
    payload,
})

export const SetStepAction = (payload: Step[]): SetStep => ({
    type: productTourTypes.SET_STEP,
    payload,
})
